import { gql } from 'apollo-boost'

const MARK_MENU_SCRAPING_TASK_MISC_AS_QC_VERIFIED = gql`
  mutation markMenuScrapingTaskMiscAsQCVerified($id: ID!, $comment: String) {
    markMenuScrapingTaskMiscAsQCVerified(id: $id, comment: $comment) {
      id
      miscTaskQCVerifiedDate
      miscTaskQCVerifiedComment
    }
  }
`

export default MARK_MENU_SCRAPING_TASK_MISC_AS_QC_VERIFIED
